module.exports = __webpack_public_path__ + "img/ad_pg.3c1a393b.jpg";